/**
 * rest/hitl.ts — Client REST HITL Assistia (S5.12-OPS-01)
 *
 * Chaque méthode passe par CircuitBreaker via RestClient.
 * Fallback : SimulationProvider si backend indisponible.
 */
// ── Implémentation ────────────────────────────────────────────────────────────
export class HitlClientImpl {
    http;
    sim;
    constructor(http, sim) {
        this.http = http;
        this.sim = sim;
    }
    getPending(classification, docType) {
        const params = new URLSearchParams();
        if (classification) {
            params.set('classification', classification);
        }
        if (docType) {
            params.set('doc_type', docType);
        }
        const query = params.toString() ? `?${params.toString()}` : '';
        return this.http.get(`/api/v1/hitl/pending${query}`, async () => {
            const list = this.sim?.listDossiers() ?? [];
            const filtered = list.filter((d) => {
                const statusMatch = d.status === 'hitl' || d.status === 'HITL_WAITING';
                const classMatch = !classification || d.classification === classification;
                const typeMatch = !docType || d.doc_type === docType;
                return statusMatch && classMatch && typeMatch;
            });
            const dossiers = filtered.map((d) => ({
                dossier_id: String(d.id),
                classification: d.classification ?? undefined,
                confidence: d.confidence !== undefined ? Number(d.confidence) : undefined,
                doc_type: d.doc_type ?? undefined,
                hitl_reason: d.hitl_reason ?? undefined,
                created_at: d.created_at ?? undefined,
            }));
            return {
                count: dossiers.length,
                dossiers,
            };
        });
    }
    validate(dossierId, approved, comment) {
        return this.http.post(`/api/v1/hitl/${dossierId}/validate`, { approved, comment }, async () => {
            return {
                dossier_id: dossierId,
                status: approved ? 'COMPLETED' : 'REJECTED',
                approved,
                validated_by: 'demo-user',
                validated_at: new Date().toISOString(),
                comment: comment ?? undefined,
                previous_status: 'HITL_WAITING',
            };
        });
    }
    getDecision(dossierId) {
        return this.http.get(`/api/v1/hitl/${dossierId}/decision`, async () => {
            return {
                dossier_id: dossierId,
                found: true,
                validated: true,
                decision: {
                    approved: true,
                    validated_by: 'demo-user',
                    validated_at: new Date().toISOString(),
                    comment: 'Simulated decision',
                },
            };
        });
    }
}
//# sourceMappingURL=hitl.js.map